export default "__VITE_ASSET__CXtA5jm0__"